import { render } from "./BurgerIcon.vue?vue&type=template&id=0abee34a"
import script from "./BurgerIcon.vue?vue&type=script&lang=js"
export * from "./BurgerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__